/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Events_NameInputs */

const en_audio_events_name = /** @type {(inputs: Audio_Events_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio Events`)
};

const fr_audio_events_name = /** @type {(inputs: Audio_Events_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événements audio`)
};

const de_audio_events_name = /** @type {(inputs: Audio_Events_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audioereignisse`)
};

const it_audio_events_name = /** @type {(inputs: Audio_Events_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventi audio`)
};

const ru_audio_events_name = /** @type {(inputs: Audio_Events_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аудиособытия`)
};

const es_audio_events_name = /** @type {(inputs: Audio_Events_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos de audio`)
};

const zh_cn2_audio_events_name = /** @type {(inputs: Audio_Events_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频事件`)
};

const ja_audio_events_name = /** @type {(inputs: Audio_Events_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオイベント`)
};

const hi_audio_events_name = /** @type {(inputs: Audio_Events_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो इवेंट्स`)
};

const pt_pt2_audio_events_name = /** @type {(inputs: Audio_Events_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos de áudio`)
};

/**
* | output |
* | --- |
* | "Audio Events" |
*
* @param {Audio_Events_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_events_name = /** @type {((inputs?: Audio_Events_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Events_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_events_name(inputs)
	if (locale === "de") return de_audio_events_name(inputs)
	if (locale === "it") return it_audio_events_name(inputs)
	if (locale === "ru") return ru_audio_events_name(inputs)
	if (locale === "es") return es_audio_events_name(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_events_name(inputs)
	if (locale === "ja") return ja_audio_events_name(inputs)
	if (locale === "hi") return hi_audio_events_name(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_events_name(inputs)
	return en_audio_events_name(inputs)
});